import { resourceReducer } from 'redux-resource';

export default resourceReducer('products');

export const getProduct = (state, id) => state.resources[id];